import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import type { ReactNode } from "react";

type Props = {
  titulo: string;
  subtitulo?: string;
  acao?: ReactNode;
  children: ReactNode;
};

export default function FinanceiroSection({
  titulo,
  subtitulo,
  acao,
  children,
}: Props) {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const accent = mode === "dark" ? "#2dd4bf" : "#0d9488";
  const accentSoft = alpha(accent, mode === "dark" ? 0.14 : 0.09);
  const borderSoft =
    mode === "dark" ? alpha("#c8e6c9", 0.35) : alpha("#7cb342", 0.18);

  return (
    <Box component="section" sx={{ mb: 3.5 }}>
      <Box
        sx={{
          mb: 2.5,
          display: "flex",
          flexWrap: "wrap",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
          py: 1.75,
          px: 2.25,
          borderRadius: "14px",
          border: `1px solid ${borderSoft}`,
          borderLeft: `4px solid ${accent}`,
          background: `linear-gradient(90deg, ${accentSoft} 0%, transparent 62%)`,
        }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            component="h2"
            sx={{
              fontWeight: 700,
              letterSpacing: "-0.01em",
              lineHeight: 1.35,
              color: "text.primary",
            }}
          >
            {titulo}
          </Typography>
          {subtitulo ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
                lineHeight: 1.55,
                maxWidth: { xs: "100%", md: "52rem" },
              }}
            >
              {subtitulo}
            </Typography>
          ) : null}
        </Box>
        {acao ? (
          <Box sx={{ flexShrink: 0, alignSelf: { xs: "stretch", sm: "center" } }}>
            {acao}
          </Box>
        ) : null}
      </Box>
      {children}
    </Box>
  );
}
